module.exports = __webpack_public_path__ + "static/img/19088A_1_C_20201008_LC.b92d895.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19088A_1_C_20201008_LC.png
// module id = EYFS
// module chunks = 0